import { HeadlessForm } from '@universal-ember/form';

<template>
  <HeadlessForm as |form|>
    <form.Field @name="payment_method" as |field|>
      <field.RadioGroup class="my-2 flex flex-col" as |group|>
        <group.Label>Payment method:</group.Label>
        <div class="flex flex-row space-x-2">
          <group.Radio @value="cc_master" as |radio|>
            <radio.Input />
            <radio.Label>Mastercard</radio.Label>
          </group.Radio>
          <group.Radio @value="cc_visa" as |radio|>
            <radio.Input />
            <radio.Label>Visa</radio.Label>
          </group.Radio>
          <group.Radio @value="paypal" as |radio|>
            <radio.Input />
            <radio.Label>Paypal</radio.Label>
          </group.Radio>
        </div>
      </field.RadioGroup>
    </form.Field>

    <button type="submit">Submit</button>
  </HeadlessForm>
</template>